import { Location } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { StorageService } from '../../core/services/storage/storage.service';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { ArrowComponent } from '../arrow/arrow.component';

@Component({
  selector: 'app-back-button',
  imports: [RouterModule, TranslatePipe, ArrowComponent],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  public backUrl = input<string>();

  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly storageService = inject(StorageService);

  public readonly theme = inject(THEME_SIGNAL);
  public GbTheme = GbTheme;

  handleData() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('checkout')) {
      this.resetData();
    }

    const url = this.backUrl();
    if (url) {
      this.router.navigate([url]);
    } else {
      this.location.back();
    }
  }

  private resetData() {
    this.storageService.clearCheckoutData();
  }
}
